<template>
	<div class="form-group" :class="{ 'has-error' : errors.has('slug'), 'has-error' : slug_in_use }">
		<label class="control-label">
			Slug *
		</label>
		<input
			v-validate="'required'"
			name="slug"
			data-vv-as="Slug"
			readonly
			v-model="item.slug"
			type="text"
			class="form-control">
		<small v-show="errors.has('slug')" class="form-text text-danger">
			{{ errors.first('slug') }}
		</small>
		<small v-show="slug_in_use" class="form-text text-danger">
			Slug en uso
		</small>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth', 'item', 'slug_in_use'],
		data () {
			return {
			}
		},
		watch: {
			'item.slug'() {
				this.checkSlug()
			},
			'item.lang_id'() {
				this.checkSlug()
			},
		},
		methods: {
			checkSlug() {
				if(this.item.slug) {
					this.$emit('changeLoading', true)
					var data = {
						id: this.item.id,
						lang_id: this.item.lang_id,
						slug: this.item.slug,
					}
					this.$http.post('admin/cms/categories/check/slug', data)
						.then(response => {
							var in_use = response.body
							this.$emit('slugInUse', in_use > 0)
							this.$emit('changeLoading', false)
						})
				} else {
					this.$emit('slugInUse', false)
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/categories/views/Slug.vue